import useSubcomponents from 'useSubcomponents'

export const useRouteOptions = () => {
    const {
        hasAccessToRequestViewMyRequestsPage,
        hasAccessToItemViewMyRequestsPage,
        hasAccessToRequestViewMyTasksPage,
        hasAccessToItemViewMyTasksPage,
        hasAccessToRequestViewAllRequestsPage,
        hasAccessToItemViewAllRequestsPage,
    } = useSubcomponents()

    const routeOptions = []
    if (
        hasAccessToRequestViewMyRequestsPage ||
        hasAccessToItemViewMyRequestsPage
    ) {
        routeOptions.push({
            name: 'MyRequests',
            title: 'MyTasks_MyRequests',
            icon: 'MTMyRequests',
            route: '/myRequests',

            children: [
                {
                    title: 'MyTasks_BusinessRequests',
                    icon: 'BusinessRolesSmall',
                    route: '/myRequests/businessRequests',
                },
                {
                    title: 'MyTasks_RequestedItems',
                    icon: 'ManagementRolesSmall',
                    route: '/myRequests/businessRequestItems',
                },
            ],
        })
    }
    if (hasAccessToRequestViewMyTasksPage || hasAccessToItemViewMyTasksPage) {
        routeOptions.push({
            name: 'MyTasks',
            title: 'MyTasks_ToDo',
            icon: 'MTTodo',
            route: '/myTasks',

            children: [
                {
                    title: 'MyTasks_BusinessRequests',
                    icon: 'BusinessRolesSmall',
                    route: '/myTasks/businessRequests',
                },
                {
                    title: 'MyTasks_RequestedItems',
                    icon: 'ManagementRolesSmall',
                    route: '/myTasks/businessRequestItems',
                },
            ],
        })
    }
    if (
        hasAccessToRequestViewAllRequestsPage ||
        hasAccessToItemViewAllRequestsPage
    ) {
        routeOptions.push({
            name: 'AllRequests',
            title: 'MyTasks_All',
            icon: 'MTAll',
            route: '/all',

            children: [
                {
                    title: 'MyTasks_BusinessRequests',
                    icon: 'BusinessRolesSmall',
                    route: '/all/businessRequests',
                },
                {
                    title: 'MyTasks_RequestedItems',
                    icon: 'ManagementRolesSmall',
                    route: '/all/businessRequestItems',
                },
            ],
        })
    }

    const hasAccessToRequestView = (name) => {
        if (name.toLowerCase() === 'myrequests')
            return hasAccessToRequestViewMyRequestsPage
        else if (name.toLowerCase() === 'mytasks')
            return hasAccessToRequestViewMyTasksPage
        else return hasAccessToRequestViewAllRequestsPage
    }
    const hasAccessToItemView = (name) => {
        if (name.toLowerCase() === 'myrequests')
            return hasAccessToItemViewMyRequestsPage
        else if (name.toLowerCase() === 'mytasks')
            return hasAccessToItemViewMyTasksPage
        else return hasAccessToItemViewAllRequestsPage
    }

    return { routeOptions, hasAccessToRequestView, hasAccessToItemView }
}
